module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c(_vm.params.componentType || 'Modal', {
    tag: "component",
    attrs: {
      "set-class": "no-padding",
      "clickOutside": _vm.clickOutside
    },
    on: {
      "close": _vm.closeTheModal
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('div', {
    staticClass: "modal-header"
  })]), _vm._v(" "), _c('div', {
    class: {
      'modal-content': true, disabled: (!_vm.open && !_vm.params.allowPrevious)
    }
  }, [_c('div', {
    staticClass: "datepicker-modal-content"
  }, [_c('div', {
    staticClass: "datepicker"
  }, [(!_vm.theStartDate || _vm.params.startDateOnly) ? _c('div', {
    staticClass: "heading"
  }, [_vm._v(_vm._s(_vm.$t('general.pick-startdate')))]) : _c('div', {
    staticClass: "heading"
  }, [_vm._v(_vm._s(_vm.$t('general.pick-enddate')))]), _vm._v(" "), _c('Datepicker', {
    ref: "pickerDate",
    attrs: {
      "type": _vm.params.type,
      "validDate": _vm.validStartDate,
      "validRangeDate": _vm.validRangeDate,
      "value": _vm.startDate,
      "value-end": _vm.endDate,
      "range": _vm.selectRange,
      "select-range": _vm.selectRange,
      "allow-previous": _vm.params.allowPrevious,
      "disabledDays": _vm.getDisabledDays,
      "specialDays": _vm.getSpecialDays,
      "startMonth": _vm.params.startMonth,
      "showAllMonths": _vm.params.showAllMonths
    },
    on: {
      "change": _vm.changedStartDate,
      "change-end": _vm.changedEndDate,
      "month-change": _vm.updateMonth
    }
  }), _vm._v(" "), (_vm.infoMessage) ? _c('div', {
    staticClass: "footer green"
  }, [(_vm.infoMessage !== '-') ? _c('div', {
    staticClass: "info"
  }, [_c('icon', {
    attrs: {
      "name": "info-blue",
      "scale": 1.5
    }
  }), _vm._v(" "), _c('span', [_vm._v("Första tillgängliga tid för hämtning av liftkort denna dag är "), _c('b', [_vm._v(_vm._s(_vm.infoMessage))])])], 1) : _vm._e(), _vm._v(" "), (_vm.infoMessage === '-') ? _c('div', {
    staticClass: "info"
  }, [_c('icon', {
    attrs: {
      "name": "info-blue",
      "scale": 1.5
    }
  }), _vm._v(" "), _c('span', [_vm._v("Det finns inga tider kvar denna dag")])], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isSummerSeason) ? _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "info info--big"
  }, [(_vm.SITE_CONFIG.accomodations.date_picker_help.summer_title) ? _c('div', [_c('icon', {
    attrs: {
      "name": "info-blue",
      "scale": 1.5
    }
  }), _vm._v(" "), _c('span', [_c('strong', {
    domProps: {
      "innerHTML": _vm._s(_vm.SITE_CONFIG.accomodations.date_picker_help.summer_title)
    }
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.accomodations.date_picker_help.summer_info1) ? _c('div', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.SITE_CONFIG.accomodations.date_picker_help.summer_info1)
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', [(_vm.SITE_CONFIG.accomodations.date_picker_help.summer_info2) ? _c('div', {
    staticStyle: {
      "width": "1.5em",
      "height": "1.5em",
      "background-color": "#005580",
      "border-radius": "50%",
      "vertical-align": "middle",
      "display": "inline-block",
      "margin-right": "10px"
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.SITE_CONFIG.accomodations.date_picker_help.summer_info2)
    }
  })]), _vm._v(" "), _c('div', [(_vm.SITE_CONFIG.accomodations.date_picker_help.summer_info3) ? _c('div', {
    staticStyle: {
      "width": "1.5em",
      "height": "1.5em",
      "background-color": "#bfd9e1",
      "border-radius": "50%",
      "vertical-align": "middle",
      "display": "inline-block",
      "margin-right": "10px"
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.SITE_CONFIG.accomodations.date_picker_help.summer_info3)
    }
  })]), _vm._v(" "), (_vm.SITE_CONFIG.accomodations.date_picker_help.summer_info4) ? _c('div', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.SITE_CONFIG.accomodations.date_picker_help.summer_info4)
    }
  })]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.params.extraInfo && _vm.params.extraInfo(_vm.theStartDate, _vm.theEndDate)[0]) ? _c('div', {
    staticClass: "footer green"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('icon', {
    attrs: {
      "name": "info-blue",
      "scale": 1.5
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.params.extraInfo(_vm.theStartDate, _vm.theEndDate)[0])
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [(_vm.theStartDate && _vm.selectRange) ? _c('div', {
    staticClass: "info",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('icon', {
    attrs: {
      "name": "info-blue",
      "scale": 1.5
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.params.infoOnPicked ? _vm.params.infoOnPicked : (_vm.params.disableSingle ? 'Du måste boka minst två dagar' : _vm.$t('skirental.pick-enddate')))
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.theStartDate && !_vm.theEndDate && !_vm.params.disableSingle),
      expression: "theStartDate && !theEndDate && !params.disableSingle"
    }]
  }, [(_vm.selectRange) ? _c('span', [(_vm.showNight) ? _c('button', {
    staticClass: "datepicker-bt block",
    staticStyle: {
      "margin-bottom": "6px"
    },
    on: {
      "click": function($event) {
        return _vm.selectDate()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('skirental.day-options.day')) + " " + _vm._s(_vm._f("date")(_vm.theStartDate)))]) : _vm._e(), _vm._v(" "), (_vm.showNight) ? _c('button', {
    staticClass: "datepicker-bt block",
    on: {
      "click": function($event) {
        return _vm.selectNight()
      }
    }
  }, [_vm._v(_vm._s(_vm.SITE_CONFIG.site === 'vallasen' ?
    _vm.$t('skirental.day-options.night') :
    (_vm.SITE_CONFIG.site === 'ulricehamn' ?
      (_vm.$t('skirental.day-options.hours', {
        hours: _vm.SITE_CONFIG.rental.night_hours
      }) + '/' + _vm.$t('general.night')) :
      _vm.$t('skirental.day-options.night')
    )) + " " + _vm._s(_vm._f("date")(_vm.theStartDate)))]) : _vm._e(), _vm._v(" "), (!_vm.showNight) ? _c('button', {
    staticClass: "datepicker-bt block",
    on: {
      "click": function($event) {
        return _vm.selectDate()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('skirental.day-options.one-day')) + " " + _vm._s(_vm._f("date")(_vm.theStartDate)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.selectRange) ? _c('button', {
    staticClass: "datepicker-bt block",
    on: {
      "click": function($event) {
        return _vm.selectDate()
      }
    }
  }, [_vm._v(_vm._s(_vm.params.terminology ? _vm.params.terminology : _vm.$t('general.cta.book')))]) : _vm._e()]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.theStartDate && !_vm.selectRange && _vm.theEndDate),
      expression: "theStartDate && !selectRange && theEndDate"
    }],
    staticClass: "datepicker-bt",
    on: {
      "click": function($event) {
        return _vm.chooseDates('day')
      }
    }
  }, [_vm._v(_vm._s(_vm.params.terminology ? _vm.params.terminology : _vm.$t('general.cta.book')) + "\n            "), (_vm.params.type === 'skiletting' && _vm.hasClosedDays) ? _c('span', [_vm._v("\n              " + _vm._s(_vm.numberOfDays) + "\n            ")]) : _c('span', [_vm._v("\n              " + _vm._s(_vm._f("dateRange")([_vm.theStartDate, _vm.theEndDate])) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "width-limit"
  }, [(!_vm.theStartDate) ? _c('div', {
    staticClass: "info"
  }, [_c('icon', {
    attrs: {
      "name": "info-blue",
      "scale": 1.5
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.params.info ? _vm.params.info : _vm.$t('skirental.departure-usage-info'))
    }
  })], 1) : _vm._e()])]), _vm._v(" "), (_vm.params.extraInfo && _vm.params.extraInfo(_vm.theStartDate, _vm.theEndDate)[4]) ? _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('icon', {
    attrs: {
      "name": "info-blue",
      "scale": 1.5
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.params.extraInfo(_vm.theStartDate, _vm.theEndDate)[4])
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.params.extraInfo && _vm.params.extraInfo(_vm.theStartDate, _vm.theEndDate)[3]) ? _c('div', {
    staticClass: "footer green"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('icon', {
    attrs: {
      "name": "info-blue",
      "scale": 1.5
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.params.extraInfo(_vm.theStartDate, _vm.theEndDate)[3])
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.params.extraInfo && _vm.params.extraInfo(_vm.theStartDate, _vm.theEndDate)[2]) ? _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('icon', {
    attrs: {
      "name": "info-blue",
      "scale": 1.5
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.params.extraInfo(_vm.theStartDate, _vm.theEndDate)[2])
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.params.extraInfo && _vm.params.extraInfo(_vm.theStartDate, _vm.theEndDate)[1]) ? _c('div', {
    staticClass: "footer green"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('icon', {
    attrs: {
      "name": "info-blue",
      "scale": 1.5
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.params.extraInfo(_vm.theStartDate, _vm.theEndDate)[1])
    }
  })], 1)]) : _vm._e()], 1)])]), _vm._v(" "), (!_vm.open && !_vm.params.allowPrevious) ? _c('div', {
    staticClass: "overlay-no-dates"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.closedMessage)
    }
  }), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        return _vm.closeTheModal()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('general.okay')))])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-35d18c86"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/DatepickerRangeModal.vue
// module id = 925
// module chunks = 0